export default "/_next/static/images/partners-desktop-62e9cfc7c85d688a185432c901a165c6.png";